<template>
  <div id="SurveyForm">
    <v-breadcrumbs :items="breadcrumbs" class="pt-0 pl-0">
      <template v-slot:divider>
        <v-icon>chevron_right</v-icon>
      </template>
      <template v-slot:item="props">
        <router-link
          :to="props.item.to"
          :class="[props.item.disabled && 'disabled']"
          >{{ props.item.text }}
        </router-link>
      </template>
    </v-breadcrumbs>
    <div class="mb-4">
      <v-layout class="align-center mt-0 grid-po-info" flat grid-list-md>
        <v-flex wrap xs-12>
          <v-card>
            <v-card-title>
              <v-toolbar-title>Reference Number Information</v-toolbar-title>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-layout row wrap>
                    <v-flex md6 xs12>Reference No:</v-flex>
                    <v-flex class="body-2" md6 xs12>{{
                      referenceInfo && referenceInfo.reference_number
                    }}</v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex md6 xs12>User name:</v-flex>
                    <v-flex class="body-2" md6 xs12>
                      <span
                        class="css-custom"
                        v-for="items in referenceInfo.users"
                        :key="items._id"
                      >
                        {{ `${items.first_name} ${items.last_name}` }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md6 xs12>
                  <v-layout row wrap>
                    <v-flex md6 xs12>Created Date:</v-flex>
                    <v-flex class="body-2" md6 xs12
                      >{{
                        referenceInfo.createdAt || morph - date("YYYY/MM/DD")
                      }}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex md6 xs12>Update Date:</v-flex>
                    <v-flex class="body-2" md6 xs12
                      >{{
                        referenceInfo.updatedAt || morph - date("YYYY/MM/DD")
                      }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReferenceService from "../services/referenceNumber.service";
import UserService from "../services/user.service.js";
import { debounce } from "lodash";
export default {
  metaInfo() {
    return {
      title: "View Reference Number Information",
    };
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Reference Number",
        disabled: false,
        to: "/reference_number",
      },
      {
        text: "Reference Number Detail",
        disabled: true,
        to: "",
      },
    ],
    referenceInfo: {},
    referenceService: new ReferenceService(),
    userService: new UserService(),
    searchUser: null,
  }),
  created() {
    this.getInfoReference();
  },
  watch: {
    searchUser(query) {
      this.querySearch({
        search: query,
      });
    },
  },
  computed: {},
  methods: {
    querySearch: debounce(function querySearch(query) {
      this.loadingSelectUser = true;
      this.userService.getList(query).then((res) => {
        this.userList = res.docs.map((e) => {
          return {
            text: [e.first_name, e.last_name].join(" ") + "<" + e.email + ">",
            value: e.id,
          };
        });
        this.loadingSelectUser = false;
      });
    }, 500),
    getInfoReference() {
      this.referenceService.getDetail(this.$route.params.id).then((res) => {
        if (res.data) {
          this.referenceInfo = res.data;
        } else {
          //   this.$router.push("/404");
        }
      });
    },
  },
};
</script>

<style>
.content-detail-job .v-card {
  width: 100%;
}

.v-overlay:before {
  opacity: 0.8;
}
.css-custom::before {
  content: ",";
}
.css-custom:first-child::before {
  content: "";
}
.file-download {
  justify-content: space-between;
  overflow-wrap: break-word;
  display: flex;
  height: 50px;
  overflow: hidden;
  margin-bottom: 10px;
}

.file-download p {
  display: inline-block;
  margin: 0;
  padding: 0;
  margin-top: 10px;
  height: 50px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.file-download a {
  margin-top: 0;
  outline-style: none;
  text-decoration: none;
}

.v-card__title {
  font-size: 18px;
  font-weight: bold;
  background-color: #f5f5f5;
}

.theme--light.v-breadcrumbs a {
  text-decoration: none;
  font-size: 16px;
}

.theme--light.v-breadcrumbs .disabled {
  color: rgba(0, 0, 0, 0.87);
  cursor: auto;
}

.elevation-1 tr td:nth-child(1) {
  min-width: 120px;
}

.elevation-1 tr td:nth-child(3) {
  min-width: 200px;
}

.elevation-1 tr td:nth-child(4) {
  max-width: 500px;
  word-break: break-word;
}

.body-2 {
  word-break: break-word;
}

table.v-table tbody td {
  word-break: break-word;
}

.truncate-content {
  max-width: 520px;
  overflow: hidden;
  max-height: 8rem;
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
}

.general_info {
  font-size: 16px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: "Roboto", sans-serif !important;
  margin: 1rem 0;
}
</style>
